import React, { useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider, } from "@material-ui/core";

// Importa componente para buscar si el contacto existe en la lista de contactos
import useContacts from "../../hooks/useContacts";

const VcardPreview = ({ contact, numbers }) => {

    const history = useHistory();
    const { user } = useContext(AuthContext);
    const [selectedQueue, setSelectedQueue] = useState("");
    const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });
    // Pasa como parámetro el número del contacto que fue recibido
    const { contacts } = useContacts({
        searchParam: numbers,
        pageNumber: 1,
        date: "",
        dateStart: "",
        dateEnd: ""
    });

    // Hace la verificación si el número recibido ya está en la lista de contactos
    const contactWithPhoneNumber = contacts.find(contact => contact.number === numbers);

    // Guarda el contacto en la lista de contactos y recarga la página al guardar.
const SaveContact = async (contatos,numberos) => {
        try {
            let contactObj = {
                name: contatos,
                number: numberos.replace(/\D/g, ""),
                email: ""
            }
            const { data } = await api.post("/contacts", contactObj);
            setContact(data);
            window.location.reload();
        } catch (err) {
            console.log(err);
            toastError(err);
        }
    };

    // Crea un nuevo chat con este contacto recibido
    const handleNewChat = async () => {
        try {
            if (contactWithPhoneNumber) {
                const queueId = selectedQueue || null;
                const whatsappId = selectedWhatsapp || null;
                const { data: ticket } = await api.post("/tickets", {
                    contactId: contactWithPhoneNumber.id,
                    userId: user.id,
                    status: "open",
                    channel: "whatsapp",
                    companyId: user.companyId,
                    queueId,
                    whatsappId,
                });
                history.push(`/tickets/${ticket.uuid}`);
            } else {
                const contactObj = {
                    name: contact,
                    number: numbers.replace(/\D/g, ""),
                    email: ""
                };
                await SaveContact(contactObj);
            }
        } catch (err) {
            toastError(err);
        }
    };

    return (
		<>
			<div style={{
				minWidth: "250px",
			}}>
				<Grid container spacing={1}>
					<Grid item xs={2}>
						<Avatar src={contactWithPhoneNumber ? contactWithPhoneNumber.profilePicUrl : ''} />
					</Grid>
					<Grid item xs={9}>
						<Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
							{contactWithPhoneNumber ? contactWithPhoneNumber.name : contact}
						</Typography>
					</Grid>
					<Grid item xs={12}>
			                    <Divider />
				                </Grid>

			                <Grid item xs={12}>
			                    <Button fullWidth color="primary" onClick={() => SaveContact(contact,numbers)} disabled={contactWithPhoneNumber?.number}>
			                        Salvar
			                    </Button>
			                </Grid>
                            <Grid item xs={12}>
			                    <Divider />
			                    <Button fullWidth color="primary" onClick={handleNewChat} disabled={!contactWithPhoneNumber?.number}>
			                        Conversar
			                    </Button>
			                </Grid>
				</Grid>
			</div>
		</>
	);
};
export default VcardPreview;
